"use strict";
/*
 * Created on 07 06 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ResultList_1 = require("./ResultList");
/**
 * <p>
 *     Extends capability of {@link ResultList} by providing capability of returning id of long running process instead of waiting fo result
 *     list. If id of process is provided, it means that result cannot be obtained yet, you should repeat a request when process is done.
 *     Filled result list is expected when you have cached/precomputed values and you do not have to run long running process at all.
 * </p>
 *
 * @param <T> type of single object of result list
 * @author JMe
 */


var AsyncOperationResultList =
/*#__PURE__*/
function (_ResultList_1$ResultL) {
  _inherits(AsyncOperationResultList, _ResultList_1$ResultL);

  /**
   * @param monitorId reference to progress monitor, if null, check result
   * @param result result list, should be used if #monitorId is null
   */
  function AsyncOperationResultList(monitorId, result) {
    var _this;

    _classCallCheck(this, AsyncOperationResultList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AsyncOperationResultList).call(this, result));
    _this.monitorId = monitorId;
    _this.result = result;
    return _this;
  }

  return AsyncOperationResultList;
}(ResultList_1.ResultList);

exports.AsyncOperationResultList = AsyncOperationResultList;